export default "__VITE_PUBLIC_ASSET__f0797c3a__"